// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__6XTIt","label":"Labeled_label__1Ewkk","divider":"Labeled_divider__3DkUB"};